/**
 * 复制到剪贴板。
 *
 * 站点是内网自托管，localhost 与 https 都算安全上下文，navigator.clipboard 可用；
 * 但用 http:// 内网 IP 直接访问时它是 undefined，所以留一条 execCommand 兜底 ——
 * 操作员点「复制」拿不到内容，比表格算错还让人骂娘。
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch {
    /* 落到下面的兜底路径 */
  }
  try {
    const ta = document.createElement('textarea')
    ta.value = text
    ta.setAttribute('aria-hidden', 'true')
    ta.style.position = 'fixed'
    ta.style.top = '-1000px'
    ta.style.opacity = '0'
    document.body.appendChild(ta)
    ta.focus()
    ta.select()
    const ok = document.execCommand('copy')
    ta.remove()
    return ok
  } catch {
    return false
  }
}
